import React from 'react';
import './styles/header.css'
import { Link } from 'react-router-i18n';
function Header(props) {
    return (
        <div className='d-flex justify-content-center header-box ' >
            <div className='header-box-container container'>
                <div className='header-navbar'>
                    <div className='header-navbar-logo'>
                        <Link to="/">
                            <img src='/logos/tom-bola-white.png'  alt="" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header;